<template>
    <v-flex xs12 v-if="black_lists.length >0">
        <v-flex class="my-2 ml-2 row" xs12>
            <v-icon left medium color="error">mdi-alpha-b-box</v-icon>
            <span class="font-weight-bold" style="color: red; font-size: 15px;">
                           Blacklist Match Found</span>
        </v-flex>
        <v-simple-table class="mb-3">
            <template v-slot:default>
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Country</th>
                    <th>Document Number</th>
                    <th>Hints</th>
                    <th>Reason for blacklisting</th>
                    <th>Action to be taken</th>
                    <th v-if="show_unmark">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in black_lists" :key="item.id">
                    <td>{{item.name}}</td>
                    <td>{{item.country_name}}</td>
                    <td>{{item.document_number}}</td>
                    <td>{{item.hints}}</td>
                    <td>{{item.reason_for_blacklisting}}</td>
                    <td>{{item.action_to_be_taken}}</td>
                    <td v-if="show_unmark">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    class="ml-2"
                                    color="red lighten-1"
                                    dark
                                    dense
                                    fab
                                    v-on="on"
                                    x-small
                                    @click="unmarkTraveller(item.id)"
                                >
                                    <v-icon small>close</v-icon>
                                </v-btn>
                            </template>
                            <span>Unmark traveller</span>
                        </v-tooltip>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-dialog persistent v-model="unmarkModel" width="700">
            <v-card>
                <v-card-title class="headline blue darken-3 white--text" default-title>Unmark traveller</v-card-title>
                <v-card-text class="pa-0">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-form ref="unmarkForm" lazy-validation class="px-2">
                                    <v-textarea
                                        label="Remarks"
                                        outlined
                                        v-model="remarks"
                                        :rules="[rules.required]"
                                    />
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="blue darken-3" class="white--text" @click="confirmUnmark" :loading="loading">Unmark
                    </v-btn>
                    <v-btn
                        color="red lighten-1"
                        class="white--text"
                        @click="unmarkModel = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>
<script>
    import ConfirmationHeaderText from "../ConfirmationHeaderText";
    import {validationMixin} from "../../mixins/validationMixin";
    import {VERSIONED_API_URL} from "../../config/config";
    import Http from "axios"

    export default {
        name: "BlackListDetail",
        props: {
            black_lists: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            traveller_id: {
                type: [Number]
            }
        },
        mixins: [validationMixin],
        computed: {
            show_unmark() {
                return !!this.traveller_id;
            }
        },
        data() {
            return {
                innerOpen: true,
                unmarkModel: false,
                remarks: '',
                loading: false,
                unmarkId: 0,
            }
        },
        methods: {
            unmarkTraveller(id) {
                this.unmarkModel = true;
                this.unmarkId = id;
            },
            async confirmUnmark() {
                if (this.$refs.unmarkForm.validate()) {
                    try {
                        const response = await Http.post(`${VERSIONED_API_URL}/unmark-traveller`, {
                            traveller_id: this.traveller_id,
                            blacklist_id: this.unmarkId,
                            remarks: this.remarks
                        });
                        this.$store.commit('Notification/showSuccess', response.data.message)
                        this.unmarkModel = false;
                        this.$emit('unmarked', this.unmarkId);
                    } catch (e) {
                        this.$store.commit('Notification/showError', 'Bad request')
                    }
                }

            }
        },
        components: {
            ConfirmationHeaderText
        }
    }
</script>
